'use client';

import { Spinner } from '@heroui/react';

export default function Loading() {
	return (
		<div className="relative flex min-h-screen flex-col place-items-center items-center justify-center self-center">
			<Spinner variant="dots" color="success" size="lg" label="Carregando..." />
		</div>
	);
}
